<template>
    <div class="notification-component" :class="type" v-if="state[type]"> 
      <div>
        <svg v-if="type === 'success'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="24" height="24" rx="12" fill="#15CE9A"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M9.81353 14.8896L6.96873 11.78L6 12.8315L9.81353 17L18 8.05145L17.0381 7L9.81353 14.8896Z" fill="white"/>
				</svg>



		  <svg v-else-if="type === 'pending'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <rect width="24" height="24" rx="12" fill="#F8CF61"/>
		  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4 13.8001H12.6V15.0001H11.4V13.8001ZM11.4 9H12.6V12.6H11.4V9ZM11.994 6C8.682 6 6 8.688 6 12C6 15.312 8.682 18 11.994 18C15.312 18 18 15.312 18 12C18 8.688 15.312 6 11.994 6ZM12 16.7999C9.34795 16.7999 7.19995 14.6519 7.19995 11.9999C7.19995 9.34793 9.34795 7.19993 12 7.19993C14.652 7.19993 16.8 9.34793 16.8 11.9999C16.8 14.6519 14.652 16.7999 12 16.7999Z" fill="white"/>
	  </svg>

		  <svg
				  v-else-if="type === 'processing' || type === 'batch_progress'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			  <circle cx="12" cy="12" r="12" fill="#17A0FB" fill-opacity="0.1"/>
			  <path d="M14.6667 9L17.6667 12L14.6667 15" stroke="#17A0FB" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
			  <path d="M10.6667 9L13.6667 12L10.6667 15" stroke="#17A0FB" stroke-opacity="0.6" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
			  <path d="M7 9L10 12L7 15" stroke="#17A0FB" stroke-opacity="0.3" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
		  </svg>
				<svg v-else-if="type === 'failed'"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="24" height="24" rx="12" fill="#E93F66"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M11.4 13.8001H12.6V15.0001H11.4V13.8001ZM11.4 9H12.6V12.6H11.4V9ZM11.994 6C8.682 6 6 8.688 6 12C6 15.312 8.682 18 11.994 18C15.312 18 18 15.312 18 12C18 8.688 15.312 6 11.994 6ZM12 16.7999C9.34795 16.7999 7.19995 14.6519 7.19995 11.9999C7.19995 9.34793 9.34795 7.19993 12 7.19993C14.652 7.19993 16.8 9.34793 16.8 11.9999C16.8 14.6519 14.652 16.7999 12 16.7999Z" fill="white"/>
				</svg>
			</div>
			<div>
				<p class="bold">{{ boldText || state[type].boldText }}</p>
				<p>{{ description || state[type].description }}</p>
			</div>
			<div class="retry" v-if="!noText && (type === 'failed' || type === 'processing')" @click="$emit('change', type)">
				{{type !== 'processing' ? 'Retry Payment' : 'Approve Payment'}}
			</div>
    </div>
</template>
<script>
import { reactive } from '@vue/composition-api'
export default {
	name: "Notification",
	props: {
		noText: {
			type: Boolean,
			default: false
		},
		boldText: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'success'
		},
		buttonText: String
	},
  model: {
    event: "change",
  },
	setup() {
		const state = reactive({
			pending: {
				boldText: 'Settlement Pending!',
				description: 'Pending settlement.'
			},
			success: {
				boldText: 'Settlement Success!',
				description: 'All payments to this account was successful.'
			},
			processing: {
				boldText: 'Settlement In Process!',
				description: 'Awaiting approval.'
			},
			failed: {
				boldText: 'Settlement Failed!',
				description: 'We couldn’t settle your payments.'
			},
			settled: {
				boldText: 'Settlement Success!',
				description: 'All payments to this account was successful.'
			},
			batch_progress: {
				boldText: 'Settlement In Process!',
				description: 'Kindly view each tranche and approve accordingly'
			},
		});

		return {
			state,
		}
	}
}
</script>
<style lang="scss" scoped>
.notification-component {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 25px;
	padding: 16px 0;

	> div {
		display: flex;
		align-items: center;
	}

	svg {
		margin-right: 16px;
	}

	p {
		font-style: normal;
		font-size: 14px;
		line-height: 16px;

	}

	.bold {
		font-weight: bold;
		color: #1D2E44;
		margin-right: 7px;
	}

	.retry {
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 16px;
		color: #0461FF;
		margin-left: 23px;
		cursor: pointer;
	}
}

.success, .settled {
	background: rgba(21, 206, 154, 0.05);
	border: 1px solid #15CE9A;
	box-sizing: border-box;
	border-radius: 4px;
}

.pending, .processing, .batch_progress {
	background: rgba(233, 63, 102, 0.05);
	border: 1px solid #F8CF61;
	box-sizing: border-box;
	border-radius: 4px;
}
.processing, .batch_progress {
	background: rgba(23, 160, 251, 0.1);
	border: 1px solid #17A0FB;
}
.failed {
	background: rgba(233, 63, 102, 0.05);
	border: 1px solid #E93F66;
	box-sizing: border-box;
	border-radius: 4px;
}
</style>